unit View.Unidades.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewUnidadesList = class(TForm)
    btNew: TButton;
    UnidadesDataset: TXDataWebDataSet;
    UnidadesDatasetid: TIntegerField;
    UnidadesDatasetaliado_id: TIntegerField;
    UnidadesDatasetdata_base_id: TIntegerField;
    UnidadesDatasetsigla: TStringField;
    UnidadesDatasetfracionaria: TBooleanField;
    UnidadesDatasetcodigo_interno: TIntegerField;
    UnidadesDatasetexcluido: TBooleanField;
    UnidadesDatasetinclusao: TDateTimeField;
    UnidadesDatasetalteracao: TDateTimeField;
    UnidadesDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewUnidadesList: TFViewUnidadesList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewUnidadesList }

procedure TFViewUnidadesList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewUnidadesList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewUnidadesList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewUnidadesList, AElementID, Result, @AfterCreate);
end;

procedure TFViewUnidadesList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewUnidadesList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewUnidadesList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      UnidadesDataset.Connection.Model.DefaultSchema.FindEntityType(UnidadesDataset.EntitySetName),
      UnidadesDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewUnidadesList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('unidades', 'active');
  TUtils.SetValorDicionarioClasses('produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_produtos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    UnidadesDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewUnidadesList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.unidades.list.pagination.info');
  btNew := TButton.Create('view.unidades.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.unidades.list.table');
  cbPageSize := TComboBox.Create('view.unidades.list.cbPageSize');
  edSearch := TEdit.Create('view.unidades.list.search');
  lcPaginator := TListControl.Create('view.unidades.list.pagination');
  UnidadesDataset := TXDataWebDataSet.Create(Self);
  UnidadesDatasetid := TIntegerField.Create(Self);
  UnidadesDatasetaliado_id := TIntegerField.Create(Self);
  UnidadesDatasetdata_base_id := TIntegerField.Create(Self);
  UnidadesDatasetsigla := TStringField.Create(Self);
  UnidadesDatasetfracionaria := TBooleanField.Create(Self);
  UnidadesDatasetcodigo_interno := TIntegerField.Create(Self);
  UnidadesDatasetexcluido := TBooleanField.Create(Self);
  UnidadesDatasetinclusao := TDateTimeField.Create(Self);
  UnidadesDatasetalteracao := TDateTimeField.Create(Self);
  UnidadesDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  UnidadesDataset.BeforeLoadDFMValues;
  UnidadesDatasetid.BeforeLoadDFMValues;
  UnidadesDatasetaliado_id.BeforeLoadDFMValues;
  UnidadesDatasetdata_base_id.BeforeLoadDFMValues;
  UnidadesDatasetsigla.BeforeLoadDFMValues;
  UnidadesDatasetfracionaria.BeforeLoadDFMValues;
  UnidadesDatasetcodigo_interno.BeforeLoadDFMValues;
  UnidadesDatasetexcluido.BeforeLoadDFMValues;
  UnidadesDatasetinclusao.BeforeLoadDFMValues;
  UnidadesDatasetalteracao.BeforeLoadDFMValues;
  UnidadesDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewUnidadesList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'sigla';
      Title := 'sigla';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fracionaria';
      Title := 'fracionaria';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    UnidadesDataset.SetParentComponent(Self);
    UnidadesDataset.Name := 'UnidadesDataset';
    UnidadesDataset.EntitySetName := 'Unidades';
    UnidadesDataset.Connection := DMConnection.ApiConnection;
    UnidadesDataset.Left := 72;
    UnidadesDataset.Top := 144;
    UnidadesDatasetid.SetParentComponent(UnidadesDataset);
    UnidadesDatasetid.Name := 'UnidadesDatasetid';
    UnidadesDatasetid.FieldName := 'id';
    UnidadesDatasetid.Required := True;
    UnidadesDatasetaliado_id.SetParentComponent(UnidadesDataset);
    UnidadesDatasetaliado_id.Name := 'UnidadesDatasetaliado_id';
    UnidadesDatasetaliado_id.FieldName := 'aliado_id';
    UnidadesDatasetaliado_id.Required := True;
    UnidadesDatasetdata_base_id.SetParentComponent(UnidadesDataset);
    UnidadesDatasetdata_base_id.Name := 'UnidadesDatasetdata_base_id';
    UnidadesDatasetdata_base_id.FieldName := 'data_base_id';
    UnidadesDatasetdata_base_id.Required := True;
    UnidadesDatasetsigla.SetParentComponent(UnidadesDataset);
    UnidadesDatasetsigla.Name := 'UnidadesDatasetsigla';
    UnidadesDatasetsigla.FieldName := 'sigla';
    UnidadesDatasetsigla.Required := True;
    UnidadesDatasetsigla.Size := 255;
    UnidadesDatasetfracionaria.SetParentComponent(UnidadesDataset);
    UnidadesDatasetfracionaria.Name := 'UnidadesDatasetfracionaria';
    UnidadesDatasetfracionaria.FieldName := 'fracionaria';
    UnidadesDatasetcodigo_interno.SetParentComponent(UnidadesDataset);
    UnidadesDatasetcodigo_interno.Name := 'UnidadesDatasetcodigo_interno';
    UnidadesDatasetcodigo_interno.FieldName := 'codigo_interno';
    UnidadesDatasetcodigo_interno.Required := True;
    UnidadesDatasetexcluido.SetParentComponent(UnidadesDataset);
    UnidadesDatasetexcluido.Name := 'UnidadesDatasetexcluido';
    UnidadesDatasetexcluido.FieldName := 'excluido';
    UnidadesDatasetinclusao.SetParentComponent(UnidadesDataset);
    UnidadesDatasetinclusao.Name := 'UnidadesDatasetinclusao';
    UnidadesDatasetinclusao.FieldName := 'inclusao';
    UnidadesDatasetalteracao.SetParentComponent(UnidadesDataset);
    UnidadesDatasetalteracao.Name := 'UnidadesDatasetalteracao';
    UnidadesDatasetalteracao.FieldName := 'alteracao';
    UnidadesDatasetexclusao.SetParentComponent(UnidadesDataset);
    UnidadesDatasetexclusao.Name := 'UnidadesDatasetexclusao';
    UnidadesDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := UnidadesDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    UnidadesDataset.AfterLoadDFMValues;
    UnidadesDatasetid.AfterLoadDFMValues;
    UnidadesDatasetaliado_id.AfterLoadDFMValues;
    UnidadesDatasetdata_base_id.AfterLoadDFMValues;
    UnidadesDatasetsigla.AfterLoadDFMValues;
    UnidadesDatasetfracionaria.AfterLoadDFMValues;
    UnidadesDatasetcodigo_interno.AfterLoadDFMValues;
    UnidadesDatasetexcluido.AfterLoadDFMValues;
    UnidadesDatasetinclusao.AfterLoadDFMValues;
    UnidadesDatasetalteracao.AfterLoadDFMValues;
    UnidadesDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
